module.exports = __webpack_public_path__ + "img/个人简历-个人简历-带文字图标.849c0331.png";